module.exports = __webpack_public_path__ + "images/bd1c8d55bc732c99d6af59a11bc615e78fe0e097bfe3673b21a2cc3c12df5982.svg";